





























































import { Component, Prop, Vue } from "vue-property-decorator";
import User from "@/ts/User";

@Component
export default class Menu extends Vue {
  active = -1;
  user = User;
}
